import { html } from 'lit';
import type { PageChangeEvent, TefComsPagination } from '@mfe-4cs/components/TefComsPagination';

export function paginationTemplate(this: TefComsPagination) {
  return html`
    <one-stack gap="lg">
      <one-pagination
        boundaries="2"
        siblings="0"
        total="${this.pagesNumber}"
        current="${this.currentPage}"
        @change="${(e: PageChangeEvent) => this.handlePageChange(e)}"
      ></one-pagination>
      <one-panel>${this.items}</one-panel>
    </one-stack>
  `;
}
